import * as L from 'leaflet';
import { ThingAlertStatus } from '../../../model';
import { MapFilterRequiredData } from '../../../model/map-filter-required-data';
import { MapContext } from '../map.component';
import { LocationForMap, ThingForMap } from '../map.service';
import { MapFilter, MARKER_SVG } from './map-filter';


export class IssueMapFilter implements MapFilter {

    private icons: any[] = [];
    private config: any;
    private context: MapContext;
    private rankDescriptor = [
        { 'label': 'No issues', value: 'NO_ISSUES', 'rank': 0, 'color': '#424242', 'clusterClass': 'cluster-no-issues', 'clusterSelectedClass': 'cluster-no-issues-selected' },
        { 'label': 'Minor anomaly', value: 'MINOR_ANOMALY', 'rank': 1, 'color': '#F2D229', 'clusterClass': 'cluster-minor-anomaly', 'clusterSelectedClass': 'cluster-minor-anomaly-selected' },
        { 'label': 'Major anomaly', value: 'MAJOR_ANOMALY', 'rank': 2, 'color': '#FFA726', 'clusterClass': 'cluster-major-anomaly', 'clusterSelectedClass': 'cluster-major-anomaly-selected' },
        { 'label': 'Failure', value: 'FAILURE', 'rank': 3, 'color': '#DF2316', 'clusterClass': 'cluster-failure', 'clusterSelectedClass': 'clustercluster-failure-selected' }
    ];

    constructor(config: any) {
        this.config = config || {};
        this.config.label = this.config.label || "Issue";
        this.rankDescriptor.forEach((rd, i) => {
            this.icons.splice(i, 0,
                L.divIcon({
                    html: MARKER_SVG,
                    className: `marker-${rd.value.replace('_', '-').toLocaleLowerCase()}`,
                    iconSize: [26, 40],
                    iconAnchor: [13, 40],
                })
            );
            this.icons.push(
                L.divIcon({
                    html: MARKER_SVG,
                    className: `marker-${rd.value.replace('_', '-').toLocaleLowerCase()}-selected`,
                    iconSize: [26, 40],
                    iconAnchor: [13, 40],
                })
            );
        });
    }

    setContext(context: MapContext): void {
        this.context = context;
    }

    getRequiredData(): MapFilterRequiredData {
        const requireData = new MapFilterRequiredData();
        if (this.context == MapContext.THINGS) {
            requireData.things = true;
            requireData.locations = false;
            requireData.alerts = false;
            requireData.events = true;
        } else {
            requireData.things = false;
            requireData.locations = true;
            requireData.alerts = false;
            requireData.events = true;
        }
        return requireData;
    }

    getConfig(): any {
        return this.config;
    }

    computeRank(elements: ThingForMap[] | LocationForMap[], data: any): void {
        let eventMap: { [key: string]: number; };
        if (this.context == MapContext.THINGS) {
            eventMap = this.getThingEvents(data.events);
        } else {
            eventMap = this.getLocationEvents(data.events);
        }
        elements.forEach(el => {
            el.rank = eventMap[el.id] || 0;
        });
    }

    updateMarker(element: ThingForMap | LocationForMap, marker: any): void {
        if (element.selected) {
            marker.setIcon(this.icons[this.rankDescriptor.length + element.rank]);
        } else {
            marker.setIcon(this.icons[element.rank]);
        }
    }

    getRankDescriptors(): any[] {
        return this.rankDescriptor;
    }

    private getThingEvents(events: ThingAlertStatus[]): { [thingId: string]: number } {
        const thingEventMap: { [thingId: string]: number } = {};
        events.forEach(e => {
            if (e.thingId) {
                const currentRank = thingEventMap[e.thingId] || 0;
                const eventRank = this.convertEventSeverityToRank(e.eventSeverity);
                if (eventRank >= currentRank) {
                    thingEventMap[e.thingId] = eventRank;
                }
            }
        });
        return thingEventMap;
    }

    private getLocationEvents(events: ThingAlertStatus[]): { [locationId: string]: number } {
        const locationEventMap: { [locationId: string]: number } = {};
        events.forEach(e => {
            const currentRank = locationEventMap[e.locationId] || 0;
            const eventRank = this.convertEventSeverityToRank(e.eventSeverity);
            if (eventRank >= currentRank) {
                locationEventMap[e.locationId] = eventRank;
            }
        });
        return locationEventMap;
    }

    private convertEventSeverityToRank(eventSeverity: number): number {
        if (!eventSeverity) {
            return 0;
        }
        const convertedSeverity = eventSeverity - 1;
        if (convertedSeverity >= 0 && convertedSeverity <= 3) {
            return convertedSeverity;
        }
        return 0;
    }

}